import { useState } from 'react';
import { CommunityInviteModal } from '../community/CommunityInviteModal';
import { IonButton } from '@ionic/react';

export const AddViewerButton: React.FC = () => {
    const [isInviteModalOpen, setIsInviteModalOpen] = useState<boolean>(false);

    return (
        <>
            <IonButton
                fill="outline"
                expand="block"
                data-type="add-viewer-button"
                onClick={() => setIsInviteModalOpen(true)}
            >Add Viewer</IonButton>

            <CommunityInviteModal
                access="view-only"
                isOpen={isInviteModalOpen}
                closeHandler={() => setIsInviteModalOpen(false)}
            />
        </>
    );
};
